import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import { Link, Redirect } from 'react-router-dom'
import Select from 'react-select';
import moment from 'moment';
import { Modal } from 'react-bootstrap';
import "@pathofdev/react-tag-input/build/index.css";
import parse from "html-react-parser";
import { setCookie, getCookie } from '../common_component/cookie.js';
import { useAuthData } from "./auth-provider.js";
import { useTheme } from "./theme-provider.js";
import { Drawer, Space } from 'antd';
import { Pagination } from 'antd';
import StatusBadge from '../common_component/StatusBadge.js';
import PageError from '../common_component/PageError.js';
import TableColumnHead from "../common_component/TableColumnHead.js";

export const ShowUsers = () => {

    const [unique_id, setUnique_id] = useState("");
    const [state, setstate] = useState(2);
    const [userTheme, setUserTheme] = useState((localStorage.getItem("kt_metronic_theme_mode_menu") === "system") ? window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light" : localStorage.getItem("kt_metronic_theme_mode_menu"))
    const [sendInvitationModalShow, setSendInvitationModalShow] = useState(false);
    const [resendInvitationModalShow, setResendInvitationModalShow] = useState(false);

    const [usersList, setUsersList] = useState([])
    const [usersListApiState, setUsersListApiState] = useState(false)
    const { theme, dropdownStyleDark } = useTheme()

    const [listCount, setListCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [searchValue, setSearchValue] = useState(null)

    const [Permission, setpermission] = useState([]);
    const [status, setstatus] = useState("");
    const [userModalShow, setUserModalShow] = useState(false);
    const [statusModalShow, setStatusModalShow] = useState(false);

    const [mailModalShow, setMailModalShow] = useState(false);
    const [Mail_content, setMail_content] = useState(null);

    const [Id, setId] = useState("");
    const [allUserList, setAllUserList] = useState([]);
    const [Name, setName] = useState("");
    const [Email, setEmail] = useState("");
    const [Mobile, setMobile] = useState("");
    const [Employee_id, setEmployee_id] = useState("");
    const [Gender, setGender] = useState("");
    const [Designation, setDesignation] = useState("");
    const [Dob_date, setDob_date] = useState("");
    const [Joining_date, setJoining_date] = useState("");
    const [Department, setDepartment] = useState("");
    const [Submit_to, setSubmit_to] = useState("");
    const [DepartmentList, setDepartmentList] = useState([]);
    const [Role, setRole] = useState("");
    const [UserRoleList, setUserRoleList] = useState([]);
    const [Profile, setProfile] = useState("");
    const [UserProfileList, setUserProfileList] = useState([]);
    const [editmodal, setEditModal] = useState([]);
    const [mainSubmitButtonState, setMainSubmitButtonState] = useState(false);
    const [DateFormat, setDateFormat] = useState("");

    const [navtype, setnavtype] = useState("Overview");
    const [open, setOpen] = useState(false);
    const [User_flag, setUser_flag] = useState(2);
    const [User_name, setUser_name] = useState("");
    const [User_details, setUser_details] = useState(null);
    const [User_history_details, setUser_history_details] = useState([]);
    const [User_mail_details, setUser_mail_details] = useState([]);

    const apiController = useRef(new AbortController())

    var page_name = "show-user";

    const { user, read, write, visibility, organization_id, user_role } = useAuthData(page_name)

    const GenderList = ["Male", "Female"].map(x => ({ label: x, value: x }))

    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };

    const onRowClick = async (obj) => {
        setOpen(true);
        setUser_details(obj);
        setUser_name(obj.name);
        setId(obj.unique_id);
        setnavtype("Overview");
        var object = {};
        object.email = user.email;
        setMainSubmitButtonState(true)
        setUser_flag(2);
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-user-details`, { method: 'POST', body: JSON.stringify({ "unique_id": obj.unique_id, "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        setMainSubmitButtonState(false)
        if (body.operation == "success") {
            setUser_mail_details(body.data[0].user_mail_details);
            setUser_history_details(body.data[0].user_history_details);
            setUser_flag(1);
        }
        else if (body.operation === "danger") {
            if (body.message === "Authorization error") {
                setUser_flag(0);
            }
        }
    }

    const onClose = () => {
        setOpen(false);
        setUser_name("");
        setId("");
        setnavtype("Overview");
        setUser_history_details([]);
        setUser_details(null);
    };


    const readOnlyStyles = {
        backgroundColor: "lightgray",
        color: "gray",
        fontSize: "12px",
        border: "1px dotted gray",
        cursor: "text"
    }

    async function getbasecurrency() {

        var object = {};
        object.email = user.email;

        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-base-currency`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.length > 0) {
            setDateFormat(body[0].date_format);
        }
    }

    async function getUserRoledetails() {
        var object = {};
        object.email = user.email;

        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-roles`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id, "service": process.env.REACT_APP_module_name }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        var temp_dropdown = [];
        if (body.length > 0) {
            body.forEach((obj) => {
                if (obj.log_status === "Active") {
                    var temp_obj = {};
                    temp_obj.label = obj.user_role;
                    temp_obj.value = obj.user_role_id;
                    temp_dropdown.push(temp_obj);
                }
            })
            setUserRoleList(temp_dropdown);
        }
    }

    async function getUserProfiledetails() {
        var object = {};
        object.email = user.email;

        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-profiles`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id, "service": process.env.REACT_APP_module_name }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        var temp_dropdown = [];
        if (body.length > 0) {
            body.forEach((obj) => {
                if (obj.log_status === "Active") {
                    var temp_obj = {};
                    temp_obj.label = obj.user_profile;
                    temp_obj.value = obj.user_profile_id;
                    temp_dropdown.push(temp_obj);
                }
            })
            setUserProfileList(temp_dropdown);
        }
    }

    async function getUserList(cp, rpp, search_v) {
        try {
            if (usersListApiState) {
                apiController.current.abort()
                apiController.current = new AbortController()
            }
            setUsersListApiState(true)

            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/user-datatable`, { signal: apiController.current.signal, method: 'POST', body: JSON.stringify({ "email": user.email, "current_page": cp - 1, "rows_per_page": rpp, "search_value": search_v, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            const body = await response.json();
            if (body.operation === "success") {
                setUsersList(body.data.list)
                setListCount(body.data.count)
            }
            else {
                throw "brand list api error"
            }

            setUsersListApiState(false);
        } catch (err) {
            if (err.name !== 'AbortError') {
                console.log(err)
            }
        }
    }

    async function getAllUserList() {
        var object = {};
        object.email = user.email;

        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-user-list`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        let temp_dropdown = body.filter(x => x.log_status === "Active").map((obj) => { return { label: obj.name + " - " + obj.user_id, value: obj.user_id } })
        setAllUserList(temp_dropdown)
    }

    async function getDeparmentDetails() {
        var object = {};
        object.email = user.email;

        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-department-by-search`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        var temp_dropdown = [];
        body.forEach((obj) => {
            if (obj.status === "Active") {
                var temp_obj = {};
                temp_obj.label = obj.department_name;
                temp_obj.value = obj.department_id;
                temp_dropdown.push(temp_obj);
            }
        })
        setDepartmentList(temp_dropdown);
    }

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {
            let p1 = getUserList(currentPage, rowsPerPage, searchValue);
            let p2 = getDeparmentDetails();
            let p3 = getUserRoledetails();
            let p4 = getUserProfiledetails();
            let p5 = getbasecurrency();
            let p6 = getAllUserList();
            Promise.all([p1, p2, p3, p4, p5, p6])
                .then(() => {
                    setstate(1);
                    console.log("all apis done")
                })
                .catch((err) => {
                    setstate(0);
                    console.log(err)
                })
        }
    }, [user, visibility, read, write])

    useEffect(() => {
        if (state == 1) {
            getUserList(currentPage, rowsPerPage, searchValue)
        }
    }, [currentPage, rowsPerPage, searchValue])


    const editDetails = (object) => {
        setId(object.unique_id)
        setName(object.name);
        setEmail(object.user_id)
        setMobile(object.distributor.mobile)
        setEmployee_id(object.distributor.Employee_id)
        setGender(object.distributor.gender)
        setDesignation(object.distributor.designation)
        setRole(object.distributor.role)
        setProfile(object.distributor.profile_id)
        //setSkip_mail(object.add_status)
        setpermission(object.distributor.permission)
        setDob_date(object.distributor.Date_of_birth)
        setJoining_date(object.distributor.Joining_date)
        setDepartment(object.distributor.department)
        setSubmit_to(object.distributor.Submit_To)
        setUserModalShow(true);
    }

    const submitStatus = (e) => {
        e.preventDefault();

        var values = { "id": Id, "status": status, "page_name": page_name, "organization_id": organization_id };
        setMainSubmitButtonState(true)
        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        axios.post(`${process.env.REACT_APP_SERVER_URL}/update-status-user`, values, headers).then((res) => {
            setMainSubmitButtonState(false)
            if (res.data && res.data.operation === "success") {
                swal("Great!", "Status changed successfully!", "success").then((value) => {
                    window.location.reload();
                });
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        });

    }

    const sendInvitation = () => {

        var values = { "id": unique_id, "page_name": page_name, "organization_id": organization_id };
        setMainSubmitButtonState(true)
        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        axios.post(`${process.env.REACT_APP_SERVER_URL}/send-invitation-mail`, values, headers).then((res) => {
            setMainSubmitButtonState(false)
            if (res.data && res.data.operation === "success") {
                swal("Great!", "Mail sent successfully!", "success").then((value) => {
                    window.location.reload();
                });
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        });
    }

    const ResendInvitation = () => {

        var values = { "user_id": unique_id, "flag": false, "page_name": page_name, "organization_id": organization_id };
        setMainSubmitButtonState(true)
        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        axios.post(`${process.env.REACT_APP_SERVER_URL}/resend-invitation-mail`, values, headers).then((res) => {
            setMainSubmitButtonState(false)
            if (res.data && res.data.operation === "success") {
                swal("Great!", "Mail sent successfully!", "success").then((value) => {
                    window.location.reload();
                });
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        });
    }

    const UpdateUser = (e) => {
        e.preventDefault();
        var object = {};
        object.organization_id = organization_id;
        object.id = Id;
        object.Employee_id = Employee_id;
        object.Submit_to = Submit_to;
        object.role = Role;
        object.profile_id = Profile;
        object.service = process.env.REACT_APP_module_name;
        object.permission = Permission;
        object.Dob_date = Dob_date;
        object.department = Department;
        object.Joining_date = Joining_date;
        object.Gender = Gender;
        object.Skip_mail = "";
        object.Designation = Designation;
        object.page_name = page_name;

        // if (object.name === "") {
        //     swal("Warning!", "Name cannot be a empty", "warning");
        //     return false;
        // }
        // var exp = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
        // if (object.email_id === "") {
        //     //console.log("7");
        //     swal("Warning!", "Please provide an email", "warning");
        //     return false;
        // }
        // else if (!object.email_id.match(exp)) {
        //     //console.log("8");
        //     swal("Warning!", "Please provide a valid email", "warning");
        //     return false;
        // }
        var oname = editmodal.filter((item) => { return item.unique_id !== object.email_id })
        for (var i = 0; i < oname.length; ++i) {
            if (oname[i].label === object.email_id) {
                swal("Oops!", "This email id already connected to your organization, try different one!", "error");
                return false;
            }
        }
        if (!object.role) {
            swal("Warning!", "Role field cannot be a empty", "warning");
            return false;
        }
        if (!object.profile_id) {
            swal("Warning!", " Profile field cannot be a empty", "warning");
            return false;
        }
        // if (object.Policy === "") {
        //     swal("Warning!", "Policy field cannot be a empty", "warning");
        //     return false;
        // }
        setMainSubmitButtonState(true)
        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/update-user`, object, headers).then((res) => {
            setMainSubmitButtonState(false)
            if (res.data && res.data.operation === "success") {
                swal("Great!", "User updated successfully!", "success").then((value) => {
                    window.location.reload();
                });
            }
            else if (res.data.operation === "same_user_name") {
                swal("Oops!", "Use a different User name!!", "error");
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        }).catch(function (error) {
            console.log(error)
        });

    }

    return (
        <>
            <div>
                <div className="d-flex flex-stack">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Users List</h1>
                </div>
                <div>
                    {
                        state == 1 ?
                            <>
                                <div className="card mb-5 mb-xl-8">
                                    <div className="card-body py-3">
                                        <div className="mb-5"><input type="text" className='form-control fw-bold border border-primary' value={searchValue || ""} onChange={(e) => { setCurrentPage(1); setSearchValue(e.target.value) }} placeholder='Search...' /></div>
                                        <div className="mb-5 d-flex justify-content-center">
                                            <Pagination
                                                total={listCount}
                                                onChange={(page, pageSize) => {
                                                    setCurrentPage(page);
                                                    if (pageSize !== rowsPerPage) {
                                                        setCurrentPage(1);
                                                    }
                                                    setRowsPerPage(pageSize);
                                                }}
                                                showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                                                pageSize={rowsPerPage}
                                                current={currentPage}
                                                showSizeChanger={true}
                                                showQuickJumper={true}
                                            />
                                        </div>
                                        <div className='overflow-auto'>
                                            <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3 min-w-1000px h-preserve-whitespace" style={{ minWidth: "1000px" }}>
                                                <thead>
                                                    <tr className="fw-bold text-muted">
                                                        <th className="min-w-80px">Name</th>
                                                        <th className="min-w-75px">User Id</th>
                                                        <th className="min-w-75px">Role</th>
                                                        <th className="min-w-120px">Profile</th>
                                                        <th className="min-w-120px">Timestamp</th>
                                                        <th className="min-w-60px">Status</th>
                                                        <th className="min-w-50px text-end">Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        usersListApiState ?
                                                            <tr>
                                                                <td colSpan={7} className="text-center pt-10">
                                                                    <div className="spinner-border text-primary"></div>
                                                                </td>
                                                            </tr>
                                                            :
                                                            usersList.length > 0 ?
                                                                usersList.map((obj) => {
                                                                    return (
                                                                        <tr key={obj.unique_id}>
                                                                            <td><span className="text-dark fw-bold mb-1 fs-6 gap-2 d-flex align-items-center"><span>{obj.name}</span><i onClick={(e) => { onRowClick(obj) }} className="fa-solid fa-eye fs-2 p-0 text-hover-primary cursor-pointer"></i></span></td>
                                                                            <td><span className="badge badge-secondary">{obj.user_id}</span></td>
                                                                            <td><span className="badge badge-primary">{obj.role}</span></td>
                                                                            <td><span className="badge badge-primary">{obj.profile}</span></td>
                                                                            <td><span className="text-dark fw-bold d-block mb-1 fs-6">{moment(obj.log_date_time).format("lll")}</span></td>
                                                                            <td><StatusBadge status={obj.user_status} entity={""} /></td>
                                                                            <td className="text-end">
                                                                                <div className="dropdown" style={{ position: "unset" }}>
                                                                                    {
                                                                                        write &&
                                                                                        <>
                                                                                            <button className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"><i className="fas fa-bars px-0"></i></button>
                                                                                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                                                                <li className="py-1"><span onClick={(e) => { editDetails(obj); }} className="dropdown-item cursor-pointer">Edit Details</span></li>
                                                                                            </ul>
                                                                                        </>
                                                                                    }
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                })
                                                                :
                                                                <tr>
                                                                    <td colSpan={7} className="text-center">
                                                                        <h3 className="text-muted pt-6">No data to be shown</h3>
                                                                    </td>
                                                                </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="mt-5 d-flex justify-content-center">
                                            <Pagination
                                                total={listCount}
                                                onChange={(page, pageSize) => {
                                                    setCurrentPage(page);
                                                    if (pageSize !== rowsPerPage) {
                                                        setCurrentPage(1);
                                                    }
                                                    setRowsPerPage(pageSize);
                                                }}
                                                showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                                                pageSize={rowsPerPage}
                                                current={currentPage}
                                                showSizeChanger={true}
                                                showQuickJumper={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </>
                            :
                            <>
                                {
                                    state === 2 ?
                                        <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                        :
                                        <PageError />
                                }
                            </>
                    }
                </div>
            </div>
            <Modal show={mailModalShow} onHide={() => { setMailModalShow() }} size="lg" centered>
                <Modal.Header>
                    <Modal.Title>Email View</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setMailModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    {Mail_content !== null &&
                        <div className="form-group row">
                            <div class="bg-light-primary border border-primary d-flex flex-column w-100 p-5 mb-10">
                                <div class="d-flex flex-wrap align-items-center mb-4 gap-1">
                                    <div class="border border-gray-300 border-dashed rounded min-w-100px py-2 px-4 mx-3 flex-grow-1">
                                        <span class="fs-6 text-gray-700 fw-bold">{Mail_content.to}</span>
                                        <div class="fw-semibold text-gray-400">Email</div>
                                    </div>
                                    <div class="border border-gray-300 border-dashed rounded min-w-100px py-2 px-4 mx-3 flex-grow-1">
                                        <span class="fs-6 text-gray-700 fw-bold">{moment(Mail_content.log_date_time).format("lll")}</span>
                                        <div class="fw-semibold text-gray-400">TimeStamp</div>
                                    </div>
                                </div>
                                {parse(Mail_content.contents)}
                            </div>

                        </div>}
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { setMailModalShow(false) }} className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                </Modal.Footer>
            </Modal>
            <Modal show={sendInvitationModalShow} onHide={() => { setSendInvitationModalShow() }} size="md" centered>
                <Modal.Header>
                    <Modal.Title>Send Invitation</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setSendInvitationModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group row">
                        <div className="col-lg-12">
                            <h3>Are you sure about send invitation?</h3>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { setSendInvitationModalShow(false) }} className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    {write && <form >
                        <button type="button" onClick={(e) => { sendInvitation() }} className="btn btn-danger" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} ><span className="indicator-label">Send</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
                    </form>}
                </Modal.Footer>
            </Modal>

            <Modal show={resendInvitationModalShow} onHide={() => { setResendInvitationModalShow() }} size="md" centered>
                <Modal.Header>
                    <Modal.Title>Resend Invitation</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setResendInvitationModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group row">
                        <div className="col-lg-12">
                            <h3>Are you sure about resend invitation?</h3>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { setResendInvitationModalShow(false) }} className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    {write && <form >
                        <button type="button" onClick={(e) => { ResendInvitation() }} className="btn btn-danger" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} ><span className="indicator-label">Resend</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
                    </form>}
                </Modal.Footer>
            </Modal>

            <Modal show={userModalShow} onHide={() => { setUserModalShow(false) }} size="lg" centered>
                <Modal.Header>
                    <Modal.Title>Edit Details</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setUserModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container'>
                        <div className="row mb-5">
                            <div className="col-md-6 fv-row">
                                <label className="required fs-5 fw-bold mb-2">Name</label>
                                <input id="department_name" type="text" className="form-control form-control-solid " placeholder="" name="department-name" value={Name} onChange={(e) => { setName(e.target.value) }} disabled readOnly />
                            </div>
                            <div className="col-md-6 fv-row">
                                <label className=" fs-5 fw-bold mb-2">Department Name</label>
                                <Select
                                    name="category"
                                    id="category"
                                    className="form-control form-control-solid"
                                    options={DepartmentList}
                                    onChange={(event) => { setDepartment(event.value) }}
                                    value={DepartmentList.filter(option => option.value == Department).length != 0 && DepartmentList.filter(option => option.value == Department)[0]}
                                    placeholder="--Choose a Department--"
                                />
                            </div>

                        </div>
                        <div className="row mb-5">
                            <div className="col-md-6 fv-row">
                                <label className="required fs-5 fw-bold mb-2">Email Address</label>
                                <input id='category_code' type="text" className="form-control form-control-solid" placeholder="" value={Email} onChange={(e) => { setEmail(e.target.value) }} disabled readOnly />
                            </div>
                            <div className="col-md-6 fv-row">
                                <label className=" fs-5 fw-bold mb-2">Mobile</label>
                                <input id='category_code' type="text" className="form-control form-control-solid" placeholder="" value={Mobile} onChange={(e) => { setMobile(e.target.value) }} disabled readOnly />
                            </div>
                        </div>
                        <div className="row mb-5">
                            <div className="col-md-6 fv-row">
                                <label className="required fs-5 fw-bold mb-2">Role</label>
                                <Select
                                    styles={userTheme == 'dark' ? dropdownStyleDark : {}}
                                    options={UserRoleList}
                                    onChange={(event) => { setRole(event.value); }}
                                    value={UserRoleList.filter(option => option.value == Role).length != 0 && UserRoleList.filter(option => option.value == Role)[0]}
                                    placeholder="--Choose a Role--"
                                />
                            </div>
                            <div className="col-md-6 fv-row">
                                <label className="required fs-5 fw-bold mb-2">Profile</label>
                                <Select
                                    styles={userTheme == 'dark' ? dropdownStyleDark : {}}
                                    options={UserProfileList}
                                    onChange={(event) => { setProfile(event.value); }}
                                    value={UserProfileList.filter(option => option.value == Profile).length != 0 && UserProfileList.filter(option => option.value == Profile)[0]}
                                    placeholder="--Choose a Profile--"
                                />
                            </div>
                        </div>
                        <div className="row mb-5">
                            <div className="col-md-6 fv-row">
                                <label className=" fs-5 fw-bold mb-2">Submits To</label>
                                <Select
                                    className="form-control form-control-solid"
                                    options={allUserList}
                                    onChange={(event) => { setSubmit_to(event.value) }}
                                    value={allUserList.filter(option => option.value == Submit_to).length != 0 && allUserList.filter(option => option.value == Submit_to)[0]}
                                    placeholder="--Select--"
                                />
                            </div>
                            <div className="col-md-6 fv-row">
                                <label className=" fs-5 fw-bold mb-2">Gender</label>
                                <Select
                                    className="form-control form-control-solid"
                                    options={GenderList}
                                    onChange={(event) => { setGender(event.value) }}
                                    value={GenderList.filter(option => option.value == Gender).length != 0 && GenderList.filter(option => option.value == Gender)[0]}
                                    placeholder="--Select--"
                                />
                            </div>
                        </div><br />
                        <div className="row mb-5">
                            <div className="col-md-6 fv-row">
                                <label className=" fs-5 fw-bold mb-2">Date of birth</label>
                                <input type="date" name="Dob_date" className="form-control" id="Dob_date" placeholder="Sales Start Date" value={Dob_date}
                                    onChange={(e) => {
                                        setDob_date(e.target.value);
                                    }}
                                />
                            </div>
                            <div className="col-md-6 fv-row">
                                <label className=" fs-5 fw-bold mb-2">Date of Joining</label>
                                <input type="date" name="Joining_date" className="form-control" id="Joining_date" placeholder="Sales Start Date" value={Joining_date}
                                    onChange={(e) => {
                                        setJoining_date(e.target.value);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger rounded" onClick={() => { setUserModalShow(false) }}>Close</button>
                    {
                        write &&
                        <button className="btn btn-success rounded" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} onClick={(e) => { UpdateUser(e); }}>
                            <span className="indicator-label">Save and Continue</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    }
                </Modal.Footer>
            </Modal>

            <Modal show={statusModalShow} onHide={() => { setStatusModalShow() }} size="md" centered>
                <Modal.Header>
                    <Modal.Title>Resend Invitation</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setStatusModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group row">
                        <div className="col-lg-12">
                            Current Status is : {(status === "Active" || status === "ACTIVE") ? <span className="fs-5 fw-bolder text-success"> Active </span> : <span className="fs-5 fw-bolder text-danger"> Deactivated </span>}
                            <h3>Are you sure about changing status?</h3>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { setStatusModalShow(false) }} className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    {write && <form >
                        {(status === "Active" || status === "ACTIVE") ? <button type="button" className="btn btn-danger" onClick={(e) => { submitStatus(e); }} data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState}><span className="indicator-label">Deactivate</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
                            :
                            <button type="button" className="btn btn-success" onClick={(e) => { submitStatus(e); }} data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState}><span className="indicator-label">Activate</span>
                                <span className="indicator-progress">Please wait...
                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>}
                    </form>}
                </Modal.Footer>
            </Modal>

            <Drawer title={User_name} width={window.innerWidth > 1200 ? 800 : 'auto'} styles={{ body: { padding: "1.5rem" } }} onClose={onClose} open={open}
                extra={
                    <Space>
                        <div className="dropdown">
                            <button className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                <i className="fas fa-bars px-0"></i>
                            </button>
                            {write &&
                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                    <a onClick={(e) => { editDetails(User_details) }} className="dropdown-item">Edit Details</a>
                                </ul>
                            }
                        </div>
                    </Space>
                }

            >
                {User_flag == 1 ?
                    <>
                        <div className="card">
                            <div className="d-flex w-100 overflow-auto">
                                <ul className="nav nav-stretch nav-line-tabs fw-bold fs-6 p-0 p-lg-10 flex-nowrap flex-grow-1">
                                    <li className="nav-item mx-lg-1">
                                        <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Overview" && "active"}`} onClick={(e) => { setnavtype("Overview"); }}>Overview</a>
                                    </li>
                                    <li className="nav-item mx-lg-1" role="presentation">
                                        <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Mail_history" && "active"}`} onClick={(e) => { setnavtype("Mail_history"); }}>Mail History</a>
                                    </li>
                                    <li className="nav-item mx-lg-1" role="presentation">
                                        <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "History" && "active"}`} onClick={(e) => { setnavtype("History"); }}>History</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="card" id="kt_profile_details_view">
                            {navtype === "Overview" ?
                                <>
                                    {(User_details != null) &&
                                        <div
                                            className="card border-primary mb-3 mt-2"
                                            style={{ border: "2px solid #007bff", borderRadius: "0.5rem", boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)" }}
                                        >
                                            <div className="card-header cursor-pointer py-3">
                                                <div className="card-title m-0">
                                                    <h3 className="fw-bold m-0">
                                                        {User_details.name}
                                                    </h3>
                                                </div>
                                            </div>
                                            <div className="card-body p-3">
                                                <div style={{ border: "1px solid #dee2e6", borderRadius: "0.5rem", padding: "10px", marginBottom: "20px" }}>
                                                    <div className="row mb-2">
                                                        <label className="col-lg-4 fw-semibold text-muted">Role</label>
                                                        <div className="col-lg-8">
                                                            <span className="fw-bold fs-6 text-gray-800">{User_details.role}</span>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-2">
                                                        <label className="col-lg-4 fw-semibold text-muted">Profile</label>
                                                        <div className="col-lg-8 fv-row">
                                                            <span className="fw-semibold text-gray-800 fs-6">{User_details.profile}</span>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-2">
                                                        <label className="col-lg-4 fw-semibold text-muted">Email</label>
                                                        <div className="col-lg-8">
                                                            <div class="d-flex align-items-center mb-2"><a className="fw-semibold fs-6 text-gray-800 text-hover-primary">{User_details.user_id}</a>

                                                                {(User_details.user_status == "danger" && User_mail_details.length > 0 && (User_mail_details[0].message_flag == "instant")) &&
                                                                    <button onClick={(e) => {/*setdealerOrg(User_details.dealer_organization_id);*/ setUnique_id(User_mail_details[0].email); setResendInvitationModalShow(true); }} className="btn btn-sm btn-light-success fw-bolder ms-2 fs-8 py-1 px-3">Resend Invitation</button>}

                                                                {(User_details.user_status == "danger" && User_mail_details.length > 0 && User_mail_details[0].message_flag == "later") &&
                                                                    <button onClick={(e) => { setUnique_id(User_mail_details[0].unique_id); setSendInvitationModalShow(true); }} className="btn btn-sm btn-light-success fw-bolder ms-2 fs-8 py-1 px-3">Send Invitation</button>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-2">
                                                        <label className="col-lg-4 fw-semibold text-muted">Mobile</label>
                                                        <div className="col-lg-8 fv-row">
                                                            <span className="fw-semibold text-gray-800 fs-6">{User_details.distributor.mobile}</span>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-2">
                                                        <label className="col-lg-4 fw-semibold text-muted">Date of birth</label>
                                                        <div className="col-lg-8 fv-row">
                                                            <span className="fw-semibold text-gray-800 fs-6">{User_details.distributor.Date_of_birth}</span>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-2">
                                                        <label className="col-lg-4 fw-semibold text-muted">Employee id</label>
                                                        <div className="col-lg-8 fv-row">
                                                            <span className="fw-semibold text-gray-800 fs-6">{User_details.distributor.Employee_id}</span>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-2">
                                                        <label className="col-lg-4 fw-semibold text-muted">Designation</label>
                                                        <div className="col-lg-8 fv-row">
                                                            <span className="fw-semibold text-gray-800 fs-6">{User_details.distributor.designation}</span>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-2">
                                                        <label className="col-lg-4 fw-semibold text-muted">Gender</label>
                                                        <div className="col-lg-8 fv-row">
                                                            <span className="fw-semibold text-gray-800 fs-6">{User_details.distributor.gender}</span>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-2">
                                                        <label className="col-lg-4 fw-semibold text-muted">Status
                                                        </label>
                                                        <div className="col-lg-8 d-flex align-items-center">
                                                            {User_details.add_status === "Active" ?
                                                                <span className="badge badge-success">{User_details.add_status}</span>
                                                                :
                                                                <span className="badge badge-danger">{User_details.add_status}</span>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="row mb-2">
                                                        <label className="col-lg-4 fw-semibold text-muted">Add date time</label>
                                                        <div className="col-lg-8">
                                                            <a className="fw-semibold fs-6 text-gray-800 text-hover-primary">{User_details.mobile}</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    }
                                </>
                                :
                                navtype === "Mail_history" ?
                                    <>

                                        {User_mail_details.map((obj3, indx3) => {
                                            return (
                                                <>
                                                    <div className="payment-details-box" key={indx3} style={{ border: "1px solid #dee2e6", borderRadius: "0.5rem", padding: "10px", marginBottom: "20px" }}>
                                                        <div className="row mb-2">
                                                            <label className="col-lg-4 fw-semibold text-muted">Mail</label>
                                                            <div className="col-lg-8">
                                                                <div class="text-gray-500 fw-semibold fs-7">
                                                                    <span class="me-2">Mail-{indx3 + 1}</span>
                                                                    <a onClick={(e) => { setMailModalShow(true); setMail_content(obj3) }} class="text-primary opacity-75-hover fw-semibold">View</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row mb-2">
                                                            <label className="col-lg-4 fw-semibold text-muted">Status</label>
                                                            <div className="col-lg-8">
                                                                {obj3.log_status === "SUCCESS" ? <span className="badge badge-success me-2">Success</span> :
                                                                    <span className="badge badge-warning me-2">Pending</span>
                                                                }
                                                                <span className="badge badge-secondary">{indx3 === 0 ? <>Send</> : <>Resend</>}</span>
                                                            </div>
                                                        </div>
                                                        <div className="row mb-2">
                                                            <label className="col-lg-4 fw-semibold text-muted">Timestamp</label>
                                                            <div className="col-lg-8">
                                                                <span className="fw-bold fs-6 text-gray-800">
                                                                    {moment(obj3.log_date_time).format("lll")}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            )
                                        })
                                        }
                                    </>
                                    :
                                    navtype === "History" &&
                                    <>
                                        <div className="card-header cursor-pointer py-0" style={{ minHeight: "45px" }}>
                                            <div className="card-title m-0">
                                                <h3 className="fw-bold m-0">History</h3>
                                            </div>
                                        </div>
                                        {User_details != undefined &&
                                            <div className="card-body p-9">
                                                {User_history_details.map((obj, index) => {
                                                    return (
                                                        <React.Fragment key={index}>
                                                            <div className="m-0">
                                                                <div className="d-flex align-items-sm-center mb-5">
                                                                    {/* <div className="timeline-icon symbol symbol-circle symbol-40px">
                                                        <div className="symbol-label bg-light">
                                                            <span className="svg-icon svg-icon-2 svg-icon-gray-500"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path opacity="0.3" d="M21.25 18.525L13.05 21.825C12.35 22.125 11.65 22.125 10.95 21.825L2.75 18.525C1.75 18.125 1.75 16.725 2.75 16.325L4.04999 15.825L10.25 18.325C10.85 18.525 11.45 18.625 12.05 18.625C12.65 18.625 13.25 18.525 13.85 18.325L20.05 15.825L21.35 16.325C22.35 16.725 22.35 18.125 21.25 18.525ZM13.05 16.425L21.25 13.125C22.25 12.725 22.25 11.325 21.25 10.925L13.05 7.62502C12.35 7.32502 11.65 7.32502 10.95 7.62502L2.75 10.925C1.75 11.325 1.75 12.725 2.75 13.125L10.95 16.425C11.65 16.725 12.45 16.725 13.05 16.425Z" fill="currentColor"></path>
                                                            <path d="M11.05 11.025L2.84998 7.725C1.84998 7.325 1.84998 5.925 2.84998 5.525L11.05 2.225C11.75 1.925 12.45 1.925 13.15 2.225L21.35 5.525C22.35 5.925 22.35 7.325 21.35 7.725L13.05 11.025C12.45 11.325 11.65 11.325 11.05 11.025Z" fill="currentColor"></path>
                                                            </svg>
                                                            </span>
                                                        </div>
                                                    </div> */}
                                                                    <div className="d-flex align-items-center flex-row-fluid flex-wrap">
                                                                        <div className="flex-grow-1 me-2">
                                                                            {obj.operation === "add" ? <span className="badge badge-lg badge-secondary fw-bold my-2">Created</span> : <span className="badge badge-lg badge-primary fw-bold my-2">Updated</span>}
                                                                            {/* <span className="text-gray-800 fw-bold d-block fs-4">{obj.operation === "voucher_creation" &&<>#<a className="text-primary fw-bold me-1">#{OBJ.MASTER_VOUCHER_NAME}</a></>}</span> */}
                                                                        </div>

                                                                        {/* <span className="badge badge-lg badge-light-success fw-bold my-2">Delivered</span> */}
                                                                    </div>
                                                                </div>
                                                                <div className="timeline">
                                                                    <div className="timeline-item align-items-center mb-7">
                                                                        <div className="timeline-line w-40px mt-6 mb-n12"></div>
                                                                        <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="currentColor"></path>
                                                                            <path d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z" fill="currentColor"></path>
                                                                            <path d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z" fill="currentColor"></path>
                                                                        </svg>
                                                                        </span>
                                                                        <div className="timeline-content m-0">
                                                                            <span className="fs-6 text-gray-400 fw-semibold d-block">Date</span>
                                                                            <span className="fs-6 fw-bold text-gray-800">{moment(obj.log_date_time).format("lll")} </span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="timeline-item align-items-center">
                                                                        <div className="timeline-line w-40px"></div>
                                                                        <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path opacity="0.3" d="M16.5 9C16.5 13.125 13.125 16.5 9 16.5C4.875 16.5 1.5 13.125 1.5 9C1.5 4.875 4.875 1.5 9 1.5C13.125 1.5 16.5 4.875 16.5 9Z" fill="currentColor"></path>
                                                                            <path d="M9 16.5C10.95 16.5 12.75 15.75 14.025 14.55C13.425 12.675 11.4 11.25 9 11.25C6.6 11.25 4.57499 12.675 3.97499 14.55C5.24999 15.75 7.05 16.5 9 16.5Z" fill="currentColor"></path>
                                                                            <rect x="7" y="6" width="4" height="4" rx="2" fill="currentColor"></rect>
                                                                        </svg>
                                                                        </span>
                                                                        <div className="timeline-content m-0">
                                                                            <span className="fs-6 text-gray-400 fw-semibold d-block">User</span>
                                                                            <span className="fs-6 fw-bold text-gray-800">{obj.user_id}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {User_history_details.length > 1 &&
                                                                <div className="separator separator-dashed my-6"></div>
                                                            }
                                                        </React.Fragment>
                                                    )
                                                })}
                                            </div>
                                        }
                                    </>
                            }
                        </div>
                    </>
                    :
                    User_flag === 2 &&
                    <div className="card">
                        <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                    </div>
                }
            </Drawer>
        </>);

};

export default ShowUsers;
